import { render } from "./CalendarPage.vue?vue&type=template&id=2978c84c"
import script from "./CalendarPage.vue?vue&type=script&lang=js"
export * from "./CalendarPage.vue?vue&type=script&lang=js"

import "./CalendarPage.vue?vue&type=style&index=0&id=2978c84c&lang=css"

import exportComponent from "/Users/nutsudaploysopon/Desktop/DevFinite/Octopus Co.,Ltd./Ncare/NCare-WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__